import React from "react";
import styles from "./styles.scss";
import { Skeleton } from "@common/skeleton";

function IndicatorsList() {
  return (
    <div className={styles.indicatorsList}>
      <div className={styles.input}>
        <Skeleton className={styles.indicatorSkeleton} />
      </div>
    </div>
  );
}

export { IndicatorsList };
